import React from 'react'
import { Skeleton } from 'antd'

const Placeholder = ({ style, ...props }) => {
  return <Skeleton.Input size="large" block style={{ width: '100%', ...style }} active {...props} />
}

export default Placeholder
